import React from 'react';
import { Button } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import { SiteNavigationLinkPropType } from '../../../../../../../../services/proptypes';
import Accordion from '../../../../../../../foundation/components/Accordion';
import Icon from '../../../../../../../foundation/components/Icon';
import { MAX_LINKS_TO_SHOW } from '../AccordionLinks/AccordionLinks.constants';
import MasonryAccordionLinks from '../MasonryAccordionLinks';
import './ParentAccordionLinks.less';
var defaultProps = {
  onMouseEnter: function onMouseEnter() {
    return null;
  },
  onMouseLeave: function onMouseLeave() {
    return null;
  },
  maxLinksToShow: MAX_LINKS_TO_SHOW,
  initialActiveIndices: [],
  onLinkClick: function onLinkClick() {
    return null;
  },
  onClose: function onClose() {
    return null;
  }
};
export default function ParentAccordionLinks(_ref) {
  var navigationGroup = _ref.navigationGroup,
    activeNavigationGroup = _ref.activeNavigationGroup,
    onAccordionClick = _ref.onAccordionClick,
    links = _ref.links,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    maxLinksToShow = _ref.maxLinksToShow,
    initialActiveIndices = _ref.initialActiveIndices,
    onLinkClick = _ref.onLinkClick,
    onClose = _ref.onClose;
  var active = activeNavigationGroup === navigationGroup;
  if (!_isEmpty(activeNavigationGroup) && !active) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Accordion.Title, {
    active: active,
    onClick: function onClick() {
      onAccordionClick(navigationGroup);
    }
  }, active && /*#__PURE__*/React.createElement(Icon, {
    className: "go-back",
    iconName: "arrow-left"
  }), /*#__PURE__*/React.createElement("span", null, navigationGroup), !active && /*#__PURE__*/React.createElement(Icon, {
    className: "display-category",
    iconName: "angle-right"
  }), active && /*#__PURE__*/React.createElement(Button, {
    className: "close-menu"
  }, /*#__PURE__*/React.createElement(Icon, {
    iconName: "xmark",
    onClick: onClose
  }))), /*#__PURE__*/React.createElement(Accordion.Content, {
    active: active,
    duration: 0
  }, /*#__PURE__*/React.createElement(MasonryAccordionLinks, {
    links: links,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    maxLinksToShow: maxLinksToShow,
    initialActiveIndices: initialActiveIndices,
    onLinkClick: onLinkClick
  })));
}
ParentAccordionLinks.defaultProps = defaultProps;